module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai505-6197de2be2d8a86564ead8ef343ecc5a.jpg";